import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MultiselectItem, MultiselectSettings, Multiselect } from '../../../core/interfaces/admin.interface';
import { PortalService } from '../../../core/services/portal.service';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-product-select',
  templateUrl: './product-select.component.html',
  styleUrls: ['./product-select.component.scss']
})
export class ProductSelectComponent implements OnInit {

  @Input() set preselectedProducts(newValue: number[]) {
    this.selectFromId(newValue);
  }

  @Input() set idPriceList(newValue: number) {
    if (newValue) {
      this.load(newValue);
    }
    this._idPriceList = newValue;
  }

  @Input() singleSelection: boolean = null;

  @Input() disabled: boolean = false;

  @Input() productsSelected: MultiselectItem[] = [];

  @Output() productsSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  _idPriceList: number;

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  get computedSettings(): MultiselectSettings {
    const base = MULTI_SELECT_SETTING[EMULTI_SELECT_SETTING.MULTIPLE_SEARCH];
    if (this.singleSelection != null) {
      return { ...base, singleSelection: this.singleSelection };
    }
    return base;
  }

  list: MultiselectItem[] = [];

  preselectedIds: number[];

  constructor(
    public portalService: PortalService,
  ) { }

  ngOnInit(): void {
    this.load(this._idPriceList);
  }

  onElementSelect(): void {
    this.productsSelectedChange.emit(this.productsSelected);
    this.onSelected.emit(this.productsSelected);
  }

  load(idPriceList: number = null) {

    let $api;

    if (idPriceList) {
      $api = this.portalService.getMultiselectItemsWithParam(Multiselect.PRODUCTS, idPriceList);
    } else {
      $api = this.portalService.getMultiselectItems(Multiselect.PRODUCTS);
    }

    $api.subscribe((response) => {

      this.list = response?.data.map(product => {

        return {
          id: product.id,
          itemName: product.name
        } as MultiselectItem

      })

      if (this.preselectedIds?.length && this.productsSelected.length == 0) {
        this.selectFromId(this.preselectedIds);
      }

    },
    (error) => {
      console.log("errore", error);
    });

  }

  selectFromId(ids: number[], withEvent: boolean = true) {

    this.preselectedIds = ids;

    this.productsSelected = this.list.filter(c => ids?.includes(c.id));

    if (withEvent) {
      this.onElementSelect();
    }

  }

}
